import { render, staticRenderFns } from "./homeBox1.vue?vue&type=template&id=5938528e&scoped=true&"
import script from "./homeBox1.vue?vue&type=script&lang=js&"
export * from "./homeBox1.vue?vue&type=script&lang=js&"
import style0 from "./homeBox1.vue?vue&type=style&index=0&id=5938528e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5938528e",
  null
  
)

export default component.exports